module.exports = __webpack_public_path__ + "img/tema-3-8.23962518.png";